import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import _toConsumableArray from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import Sortable from "sortablejs";
export default {
  data: function data() {
    return {
      language: [{
        label: '简体中文',
        value: 'cn'
      }, {
        label: '繁体中文',
        value: 'tc'
      }, {
        label: '英文',
        value: 'en'
      }, {
        label: '越语',
        value: 'vn'
      }],
      AnnouncemenTypeList: [{
        label: '系统公告',
        value: 'sys'
      }, {
        label: '游戏公告',
        value: 'game'
      }],
      AnnouncemenTypeListTow: [{
        label: '活动公告',
        value: 1
      }, {
        label: '系统公告',
        value: 2
      }],
      platformTypeList: [{
        label: '安卓',
        value: 'android'
      }, {
        label: '苹果',
        value: 'ios'
      }, {
        label: 'PC',
        value: 'pc'
      }],
      tableBody: '',
      sortReq: ''
    };
  },
  mounted: function mounted() {
    this.tableBody && this.initSort(this.tableBody, this.sortReq);
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    initSort: function initSort(type, reqFn) {
      var _this = this;

      var el = document.querySelectorAll(".".concat(type, " .el-table__body-wrapper > table > tbody"))[0];
      this.sortable = new Sortable(el, {
        animation: 150,
        delay: 0,
        onEnd: function onEnd(_ref) {
          var newIndex = _ref.newIndex,
              oldIndex = _ref.oldIndex;

          var tableList = _toConsumableArray(_this.pagingList);

          var temp;
          temp = tableList[oldIndex];
          tableList.splice(oldIndex, 1);
          tableList.splice(newIndex, 0, temp);
          var newList = tableList.map(function (i) {
            return i.sort;
          });
          console.log(newList);
          newList.sort(function (a, b) {
            return a - b;
          });
          newList.reverse();
          tableList.map(function (i, index) {
            i.sort = newList[index];
          });
          console.log(tableList);
          _this.pagingList = [];

          _this.$api[reqFn]({
            'sort_data': tableList
          });

          _this.$nextTick(function () {
            _this.pagingList = tableList;
          });
        }
      });
    }
  }
};